import { OpEdit } from "src/assets/icons";
import OpIconButton from "src/components/OpIconButton";
import { useDialogProviderContext } from "src/features/DialogProvider";
import { useTranslation } from "src/hooks";

function EditButton() {
  const { tc } = useTranslation("common");
  const { setIsOpen } = useDialogProviderContext();

  return (
    <OpIconButton
      title={tc("edit")}
      url={OpEdit}
      onClick={() => setIsOpen(true)}
    />
  );
}

export default EditButton;
